import { makeStyles } from "@material-ui/core"

export const vendorDashStyle = makeStyles((theme) => ({
    card: {
        padding: '1.5em',
        height: '100%',
        boxShadow: '2px 3px 10px #d7d6d6',
        position: 'relative',
        overflowY: 'auto'
    },
    statCard: {
        padding: '1em',
        height: '100%',
        boxShadow: '2px 3px 10px #d7d6d6',
        position: 'relative',
        overflowY: 'auto'
    },
    statTitle: {
        color: theme.palette.primary.dark,
        fontSize: '0.9em',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center'
    },
    statDesc: {
        fontSize: '0.8em',
    },
    statCount: {
        color: theme.palette.primary.dark,
        fontSize: '2.2em',
        fontWeight: 'bold'
    },
    vendorCard: {
        padding: '1em',
        boxShadow: 'none',
        border: '1px solid #d0d6dc'
    },
    vendorScore: {
        color: '#08db80',
        fontWeight: 'bold'
    },
    vendorName: {
        color: theme.palette.primary.dark,
        fontWeight: 'bold'
    },
    widgetTitle: {
        color: 'black'
    },
    noShadow: {
        boxShadow: 'none',
        border: '1px solid #d0d6dc'
    },
    exportButton: {

    }
}));